import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn'); // 日期面板月份（Jan→1月）等走 dayjs locale，须与 antd zhCN 同步
import { HashRouter } from 'react-router-dom';
import { AuthProvider } from './auth.jsx';
import App from './App.jsx';
import { loadThemeKey, applyTheme } from './theme.js';
import './utils/chartTheme.js'; // 注册品牌 ECharts 主题（主色随主题，副作用引入）
import './index.css';

// 启动即应用记忆的主题（写 data-theme + 同步 CSS 变量），并在注册 ECharts 主题前确定主色
const THEME_KEY = loadThemeKey();
const T = applyTheme(THEME_KEY);

// 设计系统 Token：品牌主色随主题（--brand 派生），财务语义色（利润红/亏损绿）保持不变
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} theme={{
      token: {
        colorPrimary: T.brand,
        colorInfo: '#378ADD',
        colorSuccess: '#3F8600',
        colorWarning: '#BA7517',
        colorError: '#CF1322',
        colorTextBase: '#26201C',
        colorText: '#26201C',
        colorBgLayout: T.antdBgLayout,
        colorBorder: T.antdBorder,
        colorBorderSecondary: T.antdBorderSecondary,
        borderRadius: 10,
        borderRadiusLG: 16,
        fontSize: 14,
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif",
      },
      components: {
        Layout: {
          headerBg: '#FFFFFF',
          siderBg: '#FFFFFF',
          headerHeight: 60,
          headerPadding: '0 24px',
          bodyBg: T.antdBgLayout,
        },
        Menu: {
          itemSelectedBg: T.antdMenuSelectedBg,
          itemSelectedColor: T.antdMenuSelectedColor,
          itemHoverBg: T.antdMenuHoverBg,
          itemHoverColor: T.antdMenuHoverColor,
          itemBorderRadius: 8,
          itemMarginInline: 8,
          itemHeight: 40,
          subMenuItemBg: '#FFFFFF',
          groupTitleColor: '#A99C90',
          activeBarBorderWidth: 0,
        },
        Table: {
          headerBg: 'transparent',
          headerColor: T.antdTableHeaderColor,
          headerSplitColor: 'transparent',
          rowHoverBg: T.antdTableRowHover,
          borderColor: T.antdBorderSecondary,
          cellPaddingBlock: 12,
        },
        Card: {
          borderRadiusLG: 16,
          headerBg: 'transparent',
          headerFontSize: 16,
        },
        Button: {
          borderRadius: 8,
          borderRadiusSM: 6,
          primaryShadow: 'none',
        },
        Modal: {
          borderRadiusLG: 14,
          headerBg: '#FFFFFF',
        },
        Statistic: {
          contentFontSize: 24,
          titleFontSize: 13,
        },
        Tag: {
          borderRadiusSM: 6,
        },
      },
    }}>
      <HashRouter>
        <AuthProvider>
          <App themeKey={THEME_KEY} />
        </AuthProvider>
      </HashRouter>
    </ConfigProvider>
  </React.StrictMode>
);
